// eslint-disable-next-line no-unused-vars
const OPTIONS_COMMAND_PKG = {
    navTitle: "Options",
    routerName: "OptionsDocs",
    commandsDescription: "Open Interest, Unusual Activity, etc...",

    commandList: [
        {
            title: "Open Interest",
            routerRef: "open-interest",
            commandString: "!oi <Symbol> <Date>",
            description: "See OI and call/put ratio for given stock",
            parameters: [
                { name: "Symbol", desc: "The symbol/ticker of the stock you want to see the OI of" },
                { name: "Date", desc: "OPTIONABLE Param - Can use this to see breakdown for the date - Date must be an option expiration date" },
            ],
            examples: [
                "!oi GOOGL",
                "!oi AMD",
                "!oi AMD 2020-09-04"
            ],
            type: "Options", 
            shortcuts: ["none"]
        },
        {
            title: "Open Interest Chart",
            routerRef: "open-interest-chart",
            commandString: "!oichart <Symbol> <Date>",
            description: "See OI and call/put ratio for given stock in a bar chart",
            parameters: [
                { name: "Symbol", desc: "The symbol/ticker of the stock you want to see the OI of" },
                { name: "Date", desc: "OPTIONABLE Param - Can use this to see breakdown for the date - Date must be an option expiration date" },
            ],
            examples: [
                "!oichart GOOGL",
                "!oichart AMD",
                "!oichart AMD 2020-09-04"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Flow Premium History",
            routerRef: "flow-prem",
            commandString: "!flowprem <Symbol>",
            description: "See last few weeks of flow premium $ value",
            parameters: [
                { name: "Symbol", desc: "The symbol/ticker of the stock you want to see" },
            ],
            examples: [
                "!flowprem GOOGL",
                "!flowprem AMD",
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Equity Put/Call Ratio",
            routerRef: "equitypc",
            commandString: "!equitypc",
            description: "Equity Put/Call Ratio from market-harmonics.com",
            parameters: ["none"],
            examples: [
                "!equitypc"
            ],
            type: "Options", 
            shortcuts: ["none"]
        },
        {
            title: "Index Put/Call Ratio",
            routerRef: "indexpc",
            commandString: "!indexpc",
            description: "Index Put/Call Ratio from market-harmonics.com",
            parameters: ["none"],
            examples: [
                "!indexpc"
            ],
            type: "Options", 
            shortcuts: ["none"]
        },
        {
            title: "Flow - Real time data",
            routerRef: "flow",
            commandString: "!flow",
            description: "Most recent flow for ticker",
            parameters: [
                { name: "Symbol", desc: "The symbol/ticker of the stock you want to see flow for" },
            ],
            examples: [
                "!flow msft",
                "!flow spy"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Opening Trades - Flow - Real time data",
            routerRef: "opening",
            commandString: "!opening",
            description: "Most recent flow for ticker with the 'opening' tag (Vol > OI)",
            parameters: [
                { name: "Symbol", desc: "The symbol/ticker of the stock you want to see flow for" },
            ],
            examples: [
                "!opening msft",
                "!opening spy"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Summary Flow",
            routerRef: "summaryflow",
            commandString: "!summaryflow <Interval> <Args>",
            description: "Summary of all flow by % of MarketCap - can also sort on other columns",
            parameters: [
                { name: "Interval: ", desc: "How many Days to go back - 0 is today - 1 includes yesterday etc" },
                { name: "Args: ", desc: "What you want to sort on (sum,float,short) does % of MC by default" },
            ],
            examples: [
                "!summaryflow 0 float",
                "!summaryflow 4",
                "!summaryflow 6 sum",
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Sector Flow",
            routerRef: "sectorflow",
            commandString: "!sectorflow <Interval> <Sector>",
            description: "Summary of all flow by % of MarketCap per sector",
            parameters: [
                { name: "Interval: ", desc: "How many Days to go back - 0 is today - 1 includes yesterday etc" },
                { name: "Sector: ", desc: "Sector to sort by - do !sectormap to get a list of all" },
            ],
            examples: [
                "!sectorflow 0 CS",
                "!sectorflow 4 E",
                "!sectorflow 6 BM",
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        //{
        //    title: "Flow Search - 30m delayed data",
        //    routerRef: "flowsearch",
        //    commandString: "!flowsearch",
        //    description: "Searching flow - First number is volume - Second number is Open interest - does greater then vol and less than open interest",
        //    parameters: [
        //        { name: "Symbol", desc: "Optionable - The symbol/ticker of the stock you want to see flow for" },
        //        { name: "Number", desc: "Search for option volume over X amount" },
        //        { name: "Number", desc: "Search for option open interest under X amount" },
        //    ],
        //    examples: [
        //        "!flowsearch msft 2000 2000",
        //       "!flowsearch spy 5000 2000"
        //    ],
        //    type: "Options",
        //    shortcuts: ["none"]
        //},
        {
            title: "Big Flow",
            routerRef: "bigflow",
            commandString: "!bigflow",
            description: "Searching flow - 20 Largest flows by Premium paid",
            parameters: [
                { name: "Symbol", desc: "Symbol for the stock" },
            ],
            examples: [
                "!bigflow msft",
                "!bigflow amd"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Flow Summary",
            routerRef: "flowsum",
            commandString: "!flowsum <Symbol>",
            description: "Summary of flow premiums over 25k in value",
            parameters: [
                { name: "Symbol", desc: "Stock Symbol" },
            ],
            examples: [
                "!flowsum msft",
                "!flowsum goog"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Flow Summary - Weekly",
            routerRef: "flowsumw",
            commandString: "!flowsumw <Symbol>",
            description: "Weekly Summary of flow premiums over 25k in value",
            parameters: [
                { name: "Symbol", desc: "Stock Symbol" },
            ],
            examples: [
                "!flowsumw msft",
                "!flowsumw goog"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Weekly Flow",
            routerRef: "weekly",
            commandString: "!weekly <Symbol>",
            description: "Weekly options with Day to Expiration < 7",
            parameters: [
                { name: "Symbol", desc: "Stock Symbol" },
            ],
            examples: [
                "!weekly msft",
                "!weekly goog"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Greek Flow",
            routerRef: "gflow",
            commandString: "!gflow <Symbol>",
            description: "Adds the greeks to the flow output - Gamma, Theta, Vega, Delta",
            parameters: [
                { name: "Symbol", desc: "Stock Symbol" },
            ],
            examples: [
                "!gflow msft",
                "!gflow goog"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Top combined Calls vs Puts flow summary",
            routerRef: "flowsumtop",
            commandString: "!flowsumtop",
            description: "Summary of prems by call and put",
            parameters: ["none"],
            examples: [
                "!flowsumtop"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Unusual Option Activity",
            routerRef: "uoa",
            commandString: "!uoa",
            description: "Top 20 Unusual Stock Option Activity - or per stock with !uoa <stock>",
            parameters: [
                { name: "Symbol", desc: "Optionable parameter to search by ticker also" },
            ],
            examples: [
                "!uoa",
                "!uoa goog"
            ],
            type: "Options", 
            shortcuts: ["none"]
        },
        {
            title: "Unusual Option Trades",
            routerRef: "uot",
            commandString: "!uot",
            description: "Top 20 Unusual Stock Option Activity - Sorted by Total Volume compared to Open Interest ",
            parameters: ["none"],
            examples: [
                "!uot"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Tendies",
            routerRef: "tendies",
            commandString: "!tendies",
            description: "The Tendies Index finds all weekly OTM options with good liquidity and " +
                "assumes the stock will hit a reasonable price target based on the stock's past 10 " +
                "days price movement, using a modified Average True Range, called Not True Range. " +
                "If that price target is hit, dividing the option's intrinsic value/current option " +
                "price gives the Tendies Index.",
            parameters: [
                { name: "Symbol", desc: "Optionable parameter to search by ticker also - no symbol will give the top 20" },
            ],
            examples: [
                "!tendies",
                "!tendies goog"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Top Strike Option Volume",
            routerRef: "toptionvol",
            commandString: "!toptionvol",
            description: "Top 20 Option Volume Leaders by Strike",
            parameters: ["none"],
            examples: [
                "!toptionvol"
            ],
            type: "Options", 
            shortcuts: ["none"]
        },
        {
            title: "Top Option Vol",
            routerRef: "tostock",
            commandString: "!tostock",
            description: "Returns the top 20 Stock Option Volume",
            parameters: ["none"],
            examples: [
                "!tostock"
            ],
            type: "Options", 
            shortcuts: ["none"]
        },
        {
            title: "Top Average Option Vol",
            routerRef: "topavgoption",
            commandString: "!topavgoption",
            description: "Top Equity Avg Option volume based on 20day average",
            parameters: ["none"],
            examples: [
                "!topavgoption"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Top OI Change",
            routerRef: "topoichange",
            commandString: "!topoichange",
            description: "Top 20 Equities with Largest Change in OI",
            parameters: ["none"],
            examples: [
                "!topiv"
            ],
            type: "Options",
            shortcuts: ["topoi"]
        },
        {
            title: "Unusual Equity Option Activity",
            routerRef: "uoastock",
            commandString: "!uoastock",
            description: "Unusual Equity option activity based on 20day Average Volume",
            parameters: ["none"],
            examples: [
                "!uoastock"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "High IV Stocks relative to the IV30",
            routerRef: "highivstock",
            commandString: "!highivstock",
            description: "20 Highest IV30 Equity stocks and the 60 day historical",
            parameters: ["none"],
            examples: [
                "!highivstock"
            ],
            type: "Options",
            shortcuts: ["none"]
        },
        {
            title: "Low IV Stocks relative to the IV30",
            routerRef: "optionstats",
            commandString: "!optionstats",
            description: "Options stats on a ticker - Volume - OI - iv - Ern Move",
            parameters: ["none"],
            examples: [
                "!optionstats"
            ],
            type: "Options",
            shortcuts: ["ostats"]
        },
        {
            title: "Top Implied Volatility Options",
            routerRef: "topiv",
            commandString: "!topiv",
            description: "Top 20 IV (Implied Volatility) Stock Options Activity",
            parameters: ["none"],
            examples: [
                "!topiv"
            ],
            type: "Options", 
            shortcuts: ["none"]
        },
        {
            title: "Top ETF Option Volume",
            routerRef: "toetf",
            commandString: "!toetf",
            description: "Returns the top 20 ETF Option Volume",
            parameters: ["none"],
            examples: [
                "!toetf"
            ],
            type: "Options", 
            shortcuts: ["none"]
        },
        {
            title: "Low Implied Volatility Options",
            routerRef: "lowiv",
            commandString: "!lowiv",
            description: "Top 20 Low IV (Implied Volatility) Stock Options Activity",
            parameters: ["none"],
            examples: [
                "!lowiv"
            ],
            type: "Options", 
            shortcuts: ["none"]
        },
        {
            title: "Top Indices Option Volume",
            routerRef: "indices",
            commandString: "!indices",
            description: "Top Indices (VIX, SPX, etc) Option Volume Leaders",
            parameters: ["none"],
            examples: [
                "!indices"
            ],
            type: "Options", 
            shortcuts: ["none"]
        },
    ]
}


export {OPTIONS_COMMAND_PKG};